/**
 * Retrieves the price for the given `bundle` based on the specified `duration` and `quantity`.
 * @param {Object} bundle
 * @param {1 | 12} duration
 * @param {number} quantity
 * @returns
 */
export const getPriceBundlePack = (bundle, duration, quantity = 1) => {
  if (!bundle) {
    return 0;
  }

  const price = bundle.prices?.[0];

  if (!price) {
    return 0;
  }

  if (duration === 12) {
    return price.yearly_price_per_unit;
  }

  if (duration === 1) {
    return price.monthly_price_per_unit;
  }

  return 0;
};
